(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('saasSummary', ["path", "policyDao", "routeHelper", "$q", function (path, policyDao, routeHelper, $q) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('summary-report/saas-summary').template('saas-summary'),
            scope: { saas: '=?' },
            link: function ($scope, element, attrs) {
                $scope.saas = $scope.saas || {};
                $scope.loading = true;
                var timeoutDeferred = $q.defer();
                var summaryDataConf = [
                    {
                        tag: 'emails_incoming',
                        labelPrefix: 'Incoming '
                    },
                    {
                        tag: 'emails_outgoing',
                        labelPrefix: 'Outgoing '
                    },
                    {
                        tag: 'files_incoming',
                        labelPrefix: 'Incoming '
                    },
                    {
                        tag: 'files_outgoing',
                        labelPrefix: 'Outgoing '
                    },
                    {
                        tag: 'users_internal',
                        label: 'Internal Users'
                    },
                    {
                        tag: 'users_external',
                        label: 'External Users'
                    }
                ];
                var summaryTagsMap = _(summaryDataConf).chain().map(function (item) {
                    return [
                        item.tag,
                        item
                    ];
                }).object().value();
                $scope.load = function () {
                    timeoutDeferred.resolve();
                    timeoutDeferred = $q.defer();
                    return policyDao.policyCatalog($scope.saas.name).params({ filterBy_tags: _(summaryTagsMap).keys().join(',') }).timeout(timeoutDeferred.promise).then(function (response) {
                        $scope.summaryRows = [];
                        _(response.data.rows).each(function (row) {
                            if (!row.context || !row.context.saas) {
                                return;
                            }
                            var tag = _(row.tags).find(function (tag) {
                                return summaryTagsMap[tag];
                            });
                            if (!tag) {
                                return;
                            }
                            var result = {
                                policies: [],
                                count: 0,
                                label: summaryTagsMap[tag].label,
                                href: routeHelper.getHref('policy-edit', { id: row.policy_id })
                            };
                            if (!result.label) {
                                var s = _(row.entity_type.split('_')).last();
                                result.label = summaryTagsMap[tag].labelPrefix + s.charAt(0).toUpperCase() + s.slice(1) + 's';
                            }
                            result.policies.push(row);
                            result.count += row.counts_match_count || 0;
                            $scope.summaryRows.push(result);
                        });
                        $scope.loading = false;
                        return $scope.summaryRows;
                    });
                };
                if (!_($scope.saas).isEmpty()) {
                    $scope.load();
                }
                $scope.$on('$locationChangeStart', function (event, next) {
                    timeoutDeferred.resolve();
                });
            }
        };
    }]);
}());